module.exports = __webpack_public_path__ + "static/media/3_review@2x.ec1fba1a.jpg";